type Address = {
    city?: string,
    country?: string,
    state?: string,
    street1?: string,
    street2?: string,
    unitNum?: string,
    zip?: string,
  };


export class EventPageData {

    public menu = null;
    public headerType: number = 1;
    public coverImage = '';
    public coverImageUrl = '';

    public info = null;
    public type = null;
    public showDateTime = null;
    public customDateTimeLabel = null;
    public registrationButtonLabelRequired = null;
    public registrationButtonLabel = null;
    public time = null;
    public address = null;
    public venueName = null;
    public timeHybrid = null;

    public name = '';
    public desc = '';

    public sponsors = [];

    public isEventActive = false;

    constructor(eventPageConfig) {
        this.menu = eventPageConfig.getMenu();
        this.headerType = eventPageConfig.getHeaderType();
        this.coverImage = eventPageConfig.getCoverImage();
        this.coverImageUrl = `url('${this.coverImage}')`;

        this.showDateTime = !eventPageConfig.hideDateTime;
        this.customDateTimeLabel = this.showDateTime ? '' : eventPageConfig.customDateTimeLabel;
        this.registrationButtonLabelRequired = eventPageConfig.registrationButtonLabelRequired;
        this.registrationButtonLabel = eventPageConfig.registrationButtonLabel;

        if (eventPageConfig.inPersonEventInfo) {
            this.info = eventPageConfig.inPersonEventInfo;
            this.type = 'in-person';
            this.time = new Date(this.info.startDateTimeGmtUnix ? this.info.startDateTimeGmtUnix * 1000 : 0);
            this.address = this.getAddress(this.info.eventVenue.address);
            this.venueName = this.info.eventVenue.name || '';

            this.sponsors = this.info.sponsors || [];
        }
        if (eventPageConfig.virtualEventInfo) {
            this.info = eventPageConfig.virtualEventInfo;
            this.type = 'virtual';
            this.time = new Date(this.info.startDateTimeGmtUnix ?this.info.startDateTimeGmtUnix * 1000 : 0);

            this.sponsors = this.info.sponsors || [];
        }
        if (eventPageConfig.hybridEventInfo) {
            this.info = eventPageConfig.hybridEventInfo;
            this.type = 'hybrid';
            this.address = this.getAddress(this.info.inPersonEvent.eventVenue.address);
            this.venueName = this.info.inPersonEvent?.eventVenue.name || '';
        
            this.timeHybrid = {
                virtual: new Date(this.info.virtualEvent.startDateTimeGmtUnix ? this.info.virtualEvent.startDateTimeGmtUnix * 1000 : 0),
                inPerson: new Date(this.info.inPersonEvent.startDateTimeGmtUnix ? this.info.inPersonEvent.startDateTimeGmtUnix * 1000 : 0)
            };

            this.sponsors = this.info.virtualEvent.sponsors || [];
        }

        this.name = eventPageConfig.name || this.info.name;
        this.desc = eventPageConfig.desc || this.info.desc;

        this.info.status === 0 ? this.isEventActive = true : this.isEventActive = false;
    }


    getAddress(addressObject: Address) {
        let address = '';
    
        if (!addressObject) {
          return '';
        }
    
        if (addressObject.street1) {
          address += addressObject.street1;
        }
    
        if (addressObject.unitNum && addressObject.unitNum !== '') {
          address += '#' + addressObject.unitNum;
        }
    
        if (addressObject.city) {
          address += address.length ? ', ' + addressObject.city : addressObject.city;
        }
    
        if (addressObject.state) {
          address += address.length ? ', ' + addressObject.state : addressObject.state;
        }
    
        if (addressObject.zip) {
          address += address.length ? ', ' + addressObject.zip : addressObject.zip;
        }
    
        return address;
    }


}